
  const $priceDom = $('#sp_price1');
  const $cPriceDom = $('#sp_price2');
  const $offPriceDom = $('.sp-price-group .sp-p span');
  const $numDom = $('#calcNumber');
  
  const productData = window.product || [];

  /** 获取当前选中的变量 */
  function getCur() {
    const opts = {
      option1: $('#sp-opt-group1 div.active').attr('data-val'),
      option2: $('#sp-opt-group2 div.active').attr('data-val'),
      option3: $('#sp-opt-group3 div.active').attr('data-val')
    };

    return productData.find(item => {
      return (!opts.option1 || item.option1 == opts.option1) &&
             (!opts.option2 || item.option2 == opts.option2) &&
             (!opts.option3 || item.option3 == opts.option3);
    });
  }

  /** 更新价格显示 */
  function changePrice() {
    const curVariant = getCur();
    if (!curVariant) return;

    const num = parseInt($numDom.val()) || 1;
    
    // 识别当前页面使用的小数点符号
    const currentText = $priceDom.text().trim();
    const decimalMatch = currentText.match(/([\.,])(\d+)(?!.*[\.,])/);
    
    const decimalSeparator = decimalMatch ? decimalMatch[1] : '.'; 
    const decimalLength = decimalMatch ? decimalMatch[2].length : 0; 

    // 格式化输出
    const formatValue = (cents) => {
      let val = (cents * num / 100).toFixed(decimalLength);
      if (decimalSeparator === ',') {
        val = val.replace('.', ',');
      }
      return val;
    };

    const price = formatValue(curVariant.price);
    const compare = formatValue(curVariant.compare_at_price);
    
    // 计算折扣
    let offPercent = 0;
    if (curVariant.compare_at_price > curVariant.price) {
      offPercent = 100 - Math.ceil((curVariant.price / curVariant.compare_at_price) * 100);
    }

    const priceRegex = /\d+(?:[.,]\d+)*/;
    const offRegex = /(\d+)(?=(?:<[^>]+>|\s)*%)/g;

    const updateHTML = ($el, regex, value) => {
      if ($el && $el.length) {
        const text = $el[0].textContent.trim();
        const newHtml = text.replace(regex, value);
        if ($el.html() !== newHtml) {
          $el.html(newHtml);
        }
      }
    };

    updateHTML($priceDom, priceRegex, price);
    updateHTML($cPriceDom, priceRegex, compare);
    updateHTML($offPriceDom, offRegex, offPercent);
  }
  
  // 绑定选项点击事件
  $(document).on('click', '.sp-option', function() {
      setTimeout(changePrice, 10);
  });

  $('.sp_buy_now').click(function () {

    let num = $numDom.val();
    let id = getCur().id;
    window.location.href = '/cart/' + id + ':' + num;

  });

﻿/**
 *
 * Most modern mobile touch slider and framework with hardware accelerated transitions
 * http://146.56.218.109:18086/wechat/index.html
 *
 * Copyright 2024-2031 Vladimir Kharlampidi
 *
 * Released under the MIT License
 *
 */

document.addEventListener('DOMContentLoaded', function () {
  let spImgList = []

  // Buy 1 price / Buy 2 price per item
  var priceMap = {
    '0-0': { sale: 9.99, orig: 19.89 },
    '0-1': { sale: 9.99, orig: 19.89 },
    '1-0': { sale: 8.99, orig: 19.89 },
    '1-1': { sale: 8.99, orig: 19.89 },
  }
  // product image index: buyIndex * 2 + typeIndex  (max 4 images, fallback to last)
  var productImages = {
    '0-0': 0, // Buy1 + Endast
    '0-1': 1, // Buy1 + Med 4-i-1
    '1-0': 2, // Buy2 + Endast
    '1-1': 3, // Buy2 + Med 4-i-1
  }

  let sp_price1 = 9.99
  let sp_price2 = 19.89

  function updatePriceDisplay() {
    let buyIdx = $('.sp-opt-group1 .sp-option.active').index()
    let typeIdx = $('.sp-opt-group2 .sp-option.active').index()
    let key = buyIdx + '-' + typeIdx
    let p = priceMap[key] || { sale: 9.99, orig: 19.89 }
    sp_price1 = p.sale
    sp_price2 = p.orig
    let qty = Number($('#calcNumber').val()) || 1
    let buyCount = buyIdx === 1 ? 2 : 1
    $('#sp_price1').html((sp_price1 * qty * buyCount).toFixed(2))
    $('#sp_price2').html((sp_price2 * qty * buyCount).toFixed(2))
  }

  function updateProductDisplay() {
    let buyIdx = $('.sp-opt-group1 .sp-option.active').index()
    let typeIdx = $('.sp-opt-group2 .sp-option.active').index()
    let key = buyIdx + '-' + typeIdx
    let imgIdx = productImages[key] || 0
    let totalImgs = $('.sp-img-inner .sp-img-p').length
    if (imgIdx >= totalImgs) imgIdx = totalImgs - 1
    $('.sp-img-inner .sp-img-p')
      .eq(imgIdx)
      .addClass('active')
      .siblings()
      .removeClass('active')
  }

  function calcTotal(price, num) {
    let result = Number(price) * Number(num)
    return result.toFixed(2)
  }

  $('.sp-reduce').click(function () {
    let input = $(this).siblings('input')[0]
    let num = Number(input.value) - 1
    if (num > 0) {
      input.value = num
    }
    updatePriceDisplay()
  })
  $('.sp-add').click(function () {
    let input = $(this).siblings('input')[0]
    let num = Number(input.value) + 1
    input.value = num
    updatePriceDisplay()
  })

  $('.sp-option').click(function () {
    $(this).siblings().removeClass('active')
    $(this).addClass('active')
    updatePriceDisplay()
    updateProductDisplay()
  })

  function getRandomNum(min, max) {
    return Math.floor(Math.random() * (max - min)) + min
  }

  let endTimeG

  function cutDownTime() {
    let nowTime = new Date()
    let endTime = new Date(endTimeG)

    let leftTime = endTime.getTime() - nowTime.getTime()
    if (leftTime < 0) {
      setupNewCountdown()
      leftTime = 0
    }
    let leftH = Math.floor((leftTime / (1000 * 60 * 60)) % 24),
      leftM = Math.floor((leftTime / (1000 * 60)) % 60),
      leftS = Math.floor((leftTime / 1000) % 60)
    leftH = leftH >= 10 ? leftH : '0' + leftH
    leftM = leftM >= 10 ? leftM : '0' + leftM
    leftS = leftS >= 10 ? leftS : '0' + leftS

    return {
      hour: leftH,
      minute: leftM,
      second: leftS,
    }
  }
  function setupNewCountdown() {
    const randomHour = getRandomNum(1, 9)
    const currentTime = new Date()
    endTimeG = currentTime.setHours(currentTime.getHours() + randomHour)
  }
  let intervalId

  function getCutDownTime() {
    setupNewCountdown()
    if (intervalId) clearInterval(intervalId)
    intervalId = setInterval(function () {
      let cutDownTimeText = cutDownTime()
      $('.sp_top_cut_down .sp_left_view .sp_hour').html(cutDownTimeText.hour)
      $('.sp_top_cut_down .sp_left_view .sp_minute').html(
        cutDownTimeText.minute
      )
      $('.sp_top_cut_down .sp_left_view .sp_second').html(
        cutDownTimeText.second
      )
    }, 1000)
  }

  getCutDownTime()

  function animateP1Slide(slide) {
    if (!slide) return
    var items = slide.querySelectorAll('.sp-ani')
    items.forEach(function (el, idx) {
      el.style.animation = 'none'
      // 触发 reflow 以便重启动画
      void el.offsetWidth
      el.style.animation = 'sp-fade-in 1.3s ease forwards'
      el.style.animationDelay = (idx * 0.4 + 0.3) + 's'
    })
  }
  animateP1Slide($('.sp_pc .sp-p1-swiper .swiper-slide')[0])
  animateP1Slide($('.sp_mobile .sp-p1-swiper .swiper-slide')[0])
  // new Swiper('.sp-p1-swiper', {
  //   autoplay: {
  //     delay: 5000,
  //     disableOnInteraction: false,
  //   },
  //   loop: false,
  //   speed: 800,
  //   effect: 'fade',
  //   fadeEffect: {
  //     crossFade: true,
  //   },
  //   on: {
  //     init: function () {
  //       console.log(this.slides[this.activeIndex],$('.sp_pc .sp-p1-swiper .swiper-slide')[0])
  //       animateP1Slide(this.slides[this.activeIndex])
  //     },
  //     slideChangeTransitionStart: function () {
  //       animateP1Slide(this.slides[this.activeIndex])
  //     },
  //   },
  // })

  new Swiper('.sp-swiper-fade-top', {
    spaceBetween: 10,
    effect: 'fade',
    autoplay: true,
    autoplay: {
      disableOnInteraction: false,
      delay: 2000,
    },
    speed: 2000,
  })
  new Swiper('.sp-swiper-fade2', {
    slidesPerView: 2,
    spaceBetween: 0,
    centeredSlides: true,
    loop: true, //寰幆婊氬姩
    freeMode: true,
    speed: 6500,
    autoplay: {
      delay: 0,
      stopOnLastSlide: false,
      disableOnInteraction: false,
    },
  })
  // 鎸夐挳杞挱
  new Swiper('.sp-bg-loop', {
    autoplay: true,
    autoplay: {
      delay: 5000,
      disableOnInteraction: false,
      reverseDirection: false,
    },
    loop: true,
  })
  new Swiper('.sp-bg-loop-m', {
    autoplay: true,
    autoplay: {
      delay: 5000,
      disableOnInteraction: false,
      reverseDirection: false,
    },
    loop: true,
  })
  new Swiper('.sp-swiper1', {
    slideShadows: true,
    slidesPerView: 'auto',
    spaceBetween: 22,
    centeredSlides: false,
    autoplay: {
      delay: 3000,
      stopOnLastSlide: false,
      disableOnInteraction: false,
    },
    navigation: {
      nextEl: '.sp_pc .sp-swiper-next',
      prevEl: '.sp_pc .sp-swiper-prev',
    },
  })
  new Swiper('.sp-swiper1-m', {
    autoplay: {
      delay: 3000,
      stopOnLastSlide: false,
      disableOnInteraction: false,
    },
    navigation: {
      nextEl: '.sp_mobile .sp-swiper-next',
      prevEl: '.sp_mobile .sp-swiper-prev',
    },
  })
  var swiper2 = new Swiper('.sp-swiper2', {
    effect: 'fade',
    loop: true, //寰幆婊氬姩
    autoplay: {
      delay: 3000,
      stopOnLastSlide: false,
      disableOnInteraction: false,
    },
    on: {
      slideChange: function () {
        $('.sp_pc .sp-p7-list li').eq(this.realIndex).addClass('active').siblings().removeClass('active')
      },
    }
  })
  $('.sp_pc .sp-p7-list li').click(function () {
    let index = $(this).index()
    $(this).addClass('active').siblings().removeClass('active')
    swiper2.slideToLoop(index, 1000, false);
  })
  var swiper2_m = new Swiper('.sp-swiper2-m', {
    effect: 'fade',
    loop: true, //寰幆婊氬姩
    autoplay: {
      delay: 3000,
      stopOnLastSlide: false,
      disableOnInteraction: false,
    },
    on: {
      slideChange: function () {
        $('.sp_mobile .sp-p7-list li').eq(this.realIndex).addClass('active').siblings().removeClass('active')
      },
    }
  })
  $('.sp_mobile .sp-p7-list li').click(function () {
    let index = $(this).index()
    $(this).addClass('active').siblings().removeClass('active')
    swiper2_m.slideToLoop(index, 1000, false);
  })
  new Swiper('.sp-swiper3', {
    slideShadows: true,
    slidesPerView: 'auto',
    spaceBetween: 40,
    centeredSlides: true,
    loop: true, //寰幆婊氬姩
    freeMode: true,
    speed: 6500,
    autoplay: {
      delay: 0,
      stopOnLastSlide: false,
      disableOnInteraction: false,
    },
  })
  new Swiper('.sp-swiper4', {
    slideShadows: true,
    slidesPerView: 'auto',
    spaceBetween: 95,
    centeredSlides: true,
    loop: true, //寰幆婊氬姩
    freeMode: true,
    speed: 6500,
    autoplay: {
      delay: 0,
      stopOnLastSlide: false,
      disableOnInteraction: false,
    },
  })
  new Swiper('.sp-swiper4-m', {
    slideShadows: true,
    slidesPerView: 3.6,
    spaceBetween: 40,
    centeredSlides: true,
    loop: true, //寰幆婊氬姩
    freeMode: true,
    speed: 3500,
    autoplay: {
      delay: 0,
      stopOnLastSlide: false,
      disableOnInteraction: false,
    },
  })
  new Swiper('.sp-swiper5', {
    slideShadows: true,
    slidesPerView: 2,
    spaceBetween: 50,
    centeredSlides: true,
    loop: true, //寰幆婊氬姩
    freeMode: true,
    speed: 6500,
    autoplay: {
      delay: 0,
      stopOnLastSlide: false,
      disableOnInteraction: false,
    },
  })
  new Swiper('.sp-swiper5-m', {
    slidesPerView: 'auto',
    spaceBetween: 38,
    centeredSlides: true,
    loop: true,
    freeMode: true,
    speed: 3000,
    autoplay: {
      delay: 0,
      stopOnLastSlide: false,
      disableOnInteraction: false,
    },
  })
  new Swiper('.sp-swiper7-m', {
    slidesPerView: 'auto',
    spaceBetween: 44,
    centeredSlides: true,
    loop: true,
    freeMode: true,
    speed: 6500,
    autoplay: {
      delay: 0,
      stopOnLastSlide: false,
      disableOnInteraction: false,
    },
  })
  new Swiper('.sp-swiper5b-m', {
    slidesPerView: 'auto',
    spaceBetween: 100,
    centeredSlides: true,
    loop: true,
    freeMode: true,
    speed: 5500,
    autoplay: {
      delay: 0,
      stopOnLastSlide: false,
      disableOnInteraction: false,
    },
  })
  jQuery('.sp-scroll2').slide({
    mainCell: '.nav-imgs',
    autoPlay: true,
    effect: 'leftMarquee',
    interTime: 12,
    vis: 1,
    scroll: 1,
  })

  let _swiper = new Swiper('.sp-swiper-pro', {
    speed: 1,
    spaceBetween: 0,
  })

  function mainRender() {
    $(function () {
      $('#root').css('zoom', 'normal')
      if (document.body.clientWidth <= 1080) {
        let scale = document.body.clientWidth / 1080
        $('#root').css('zoom', scale)
      } else {
        const scale = document.body.clientWidth / 1920
        $('#root').css('zoom', scale)
      }

      window.addEventListener(
        'resize',
        (function () {
          var timer
          return function () {
            if (timer) clearTimeout(timer)
            timer = setTimeout(function () {
              $('#root').css('zoom', 'normal')
              if (document.body.clientWidth <= 1080) {
                let scale = document.body.clientWidth / 1080
                $('#root').css('zoom', scale)
              } else {
                const scale = document.body.clientWidth / 1920
                $('#root').css('zoom', scale)
              }
            }, 100)
          }
        })()
      )
    })

    function lazyLoadImages() {
      const images = document.querySelectorAll('.lazy-load')
      const config = {
        rootMargin: '0px 0px 1300px 0px',
        threshold: 0,
      }

      const lazyLoadObserver = new IntersectionObserver(function (
        entries,
        observer
      ) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            // 褰撳浘鐗囪繘鍏ヨ鍙ｆ椂
            const image = entry.target
            const dataSrc = image.getAttribute('data-src')
            image.src = dataSrc // 灏哾ata-src灞炴€х殑鍊艰缃负鍥剧墖鐨勫疄闄呭湴鍧€
            lazyLoadObserver.unobserve(image)
          }
        })
      },
        config)

      images.forEach(function (image) {
        lazyLoadObserver.observe(image)
      })
    }

    function preloadImages(imageArray) {
      if (Array.isArray(imageArray[0])) {
        // 澶勭悊浜岀淮鏁扮粍
        imageArray.forEach((subArray) => {
          subArray.forEach((url) => {
            const img = new Image()
            img.src = url
          })
        })
      } else {
        imageArray.forEach((url) => {
          const img = new Image()
          img.src = url
        })
      }
    }

    lazyLoadImages()

    preloadImages(spImgList)

    var links = document.querySelectorAll('a[href^="#shopping"]')
    links.forEach(function (link) {
      link.addEventListener('click', function (event) {
        event.preventDefault() // 闃绘榛樿鐨勮烦杞涓?
        // 鏂瑰紡涓€
        const targetElement = document.getElementById('shopping') // 鑾峰彇璺宠浆鐩爣鑺傜偣
        const offsetTop =
          document.body.clientWidth <= 1080
            ? targetElement.offsetTop - $('.sp-nav').height()
            : targetElement.offsetTop - 0
        let sptop = document.body.clientWidth <= 1080 ? 0 : 70

        window.scroll({
          top:
            offsetTop * $('div#root').css('zoom') -
            sptop * $('div#root').css('zoom'),
          behavior: 'smooth', // 浣跨敤 smooth 瀹炵幇骞虫粦婊氬姩
        })
      })
    })

    // IOS瀛椾綋澶氫簡闂磋窛鐨勫鐞?缁欒妭鐐规坊鍔?sp_system 绫诲悕
    var userAgent = navigator.userAgent || navigator.vendor || window.opera
    var isAndroid = /android/i.test(userAgent)
    var isIOS = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream
    var isPC = !isAndroid && !isIOS && !/Iron/.test(userAgent) // 娣诲姞浜嗗 "Iron" 鍏抽敭璇嶇殑鍒ゆ柇

    if (isAndroid) {
      console.log('Android')
    } else if (isIOS) {
      console.log('iOS')
    } else if (isPC) {
      console.log('PC')
    } else {
      $('.sp_system').css('letter-spacing', '-4px')
    }
  }

  mainRender()

  // 鏍囬鏂囨湰娓愬嚭
  const graduallyList = document.getElementsByClassName('gradually')
  for (let gradually of graduallyList) {
    const spans = gradually.querySelectorAll('span')
    const paragraph = gradually.querySelector('.sp-sub-title')
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const highlight = gradually.querySelector('.sp-color')
            // 缁欐瘡涓?span 鍜?i 鍔ㄧ敾
            spans.forEach((span, index) => {
              span.style.animation = `swift-up-fade 0.5s ease forwards`
              span.style.animationDelay = `${index * 0.1}s`
              const i = span.querySelector('i')
              if (i) {
                i.style.animation = `swift-up-fade 0.5s ease forwards`
                i.style.animationDelay = `${index * 0.1}s`
              }
              if (index == spans.length - 1 && highlight) {
                setTimeout(() => {
                  highlight.classList.add('active');
                }, 700);
              }
            })

            // 娈佃惤
            const totalDelay = spans.length * 0.1 + 0.3
            if (paragraph) {
              paragraph.style.animation = `swift-up-fade 0.5s ease forwards`
              paragraph.style.animationDelay = `${totalDelay}s`
            }

            observer.unobserve(gradually)
          }
        })
      },
      {
        threshold: 0.3,
      }
    )
    observer.observe(gradually)
  }

  // // 鐐瑰嚮鎸夐挳
  // $(".sp-video-btn").click(function () {
  //   $(".sp-mask").css("display", "flex");
  // });

  // 鑿滃崟
  $('.sp-menu-btn').click(function (e) {
    $('.sp-menu-mask').show()
  })

  $('.sp-menu-mask').click(function (e) {
    // if ($(e.target).closest(".sp-menu-mask li").length > 0) {
    // } else {
    $('.sp-menu-mask').hide()
    // }
  })

  // 婊氬姩闅愯棌椤堕儴
  if (
    $(window).scrollTop() >
    $('.sp_header').height() * $('div#root').css('zoom')
  ) {
    $('.sp_header-wrap').addClass('sp-fixed')
  } else {
    $('.sp_header-wrap').removeClass('sp-fixed')
  }

  let spTimer = null
  let spHasShown = false // 闃叉閲嶅鏄剧ず
  document.querySelector('.sp-btn-style2').style.display = 'none'
  $(window).scroll(function () {
    if (
      $(window).scrollTop() >
      $('.sp_header').height() * $('div#root').css('zoom')
    ) {
      $('.sp_header-wrap').addClass('sp-fixed')
    } else {
      $('.sp_header-wrap').removeClass('sp-fixed')
    }

    // 婊氬姩娣诲姞搴曢儴
    if (spHasShown) return // 宸茬粡鏄剧ず灏变笉鍐嶈Е鍙?
    if ($(window).scrollTop() > 600) {
      spTimer = setTimeout(function () {
        document.querySelector('.sp-btn-style2').style.display = 'flex'
        spHasShown = false // 鏍囪涓哄凡鏄剧ず
      }, 500)
    } else {
      spTimer = setTimeout(function () {
        document.querySelector('.sp-btn-style2').style.display = 'none'
        spHasShown = false // 鏍囪涓哄凡鏄剧ず
      }, 500)
    }
  })

  $(document).on('click', '.sp_buy_now', function () {
    console.log('xxx111')
  })

  let initNum = 0
  $(document).on('click', '.sp_add_cart', function () {
    $(this).children('img').addClass('on')
    $('.sp-cart .num').show()
    setTimeout(function () {
      $(' .cart-btn').children('img').removeClass('on')
    }, 500)
    $(' .sp-cart').addClass('on')
    setTimeout(function () {
      $('.sp-cart').removeClass('on')
    }, 500)

    var data = {
        id: getCur().id,
        quantity: $('#calcNumber').val(),
      };
      $.ajax({
        type: "POST",
        url: "/cart/add.js",
        data: data,
        success: function () {
          $.getJSON(window.Shopify.routes.root + "cart.js", function (result) {
            // $("#cardNum").html(result.item_count);
            $(".cardNum").each(function () {
                $(this).html(result.item_count);
                $(this).removeClass("sp-gray");

            });
          });
        },
        dataType: "json",
      });

    var imgs = $('.sp_product_part .sp-img-inner .sp-img-p.active')
    // var imgs = $(".sp_product_part .sp-img-p.active");

    imgs.each(function () {
      var $img = $(this)
      var flyer = $img[0].cloneNode(true)
      flyer.classList.add('sp_clone')
      $('.sp_product_part').append(flyer)
      $(flyer).css({
        width: $img[0].width,
        height: $img[0].height,
        background: '#e7e9ef',
        position: 'fixed',

        top: $img[0].offsetTop,
        left: $img.offset().left,
        'z-index': 99,
      })
      let finish
      if (document.body.clientWidth <= 1080) {
        finish = $('.sp-btn-style2 .sp-cart')

        $(flyer).animate(
          {
            top: $('.sp-btn-style2')[0].offsetTop,
            left:
              $('.sp-btn-style2 .sp-cart')[0].offsetLeft + finish.width() / 2,
            width: 50,
            height: 50,
            opacity: 0.4,
          },
          500,
          'linear',
          function () {
            $(this).animate(
              {
                width: 0,
                height: 0,
                opacity: 0,
              },
              0,
              function () {
                $(this).detach()
              }
            )
          }
        )
      } else {
        finish = $('.sp_pc .sp-cart')
        $(flyer).animate(
          {
            top: finish[0].offsetTop,
            left: finish[0].offsetLeft + finish.width() / 2,
            width: 50,
            height: 50,
            opacity: 0.4,
          },
          500,
          'linear',
          function () {
            $(this).animate(
              {
                width: 0,
                height: 0,
                opacity: 0,
              },
              0,
              function () {
                $(this).detach()
              }
            )
          }
        )
      }
    })
  })

  // 闂瓟
  $('.sp-qa2-question').on('click', function () {
    var $currentItem = $(this).closest('.sp-qa2-item')
    var $answer = $currentItem.find('.sp-qa2-answer')

    if ($currentItem.hasClass('active')) {
      $answer.slideUp(300)
      $currentItem.removeClass('active')
    }
    // 濡傛灉褰撳墠椤规槸鍏抽棴鐨?-> 寮€鍚畠 (骞跺叧闂叾浠栭」)
    else {
      // 鍏抽棴鍏朵粬鎵€鏈夐」
      $('.sp-qa2-item').removeClass('active')
      $('.sp-qa2-answer').slideUp(300)

      // 寮€鍚綋鍓嶉」
      $currentItem.addClass('active')
      $answer.slideDown(300)
    }
  })

  // 鏂囨湰娓愬嚭鍔ㄧ敾
  const graduallyList2 = document.getElementsByClassName('sp-fade-box')
  for (let gradually2 of graduallyList2) {
    const paragraph2 = gradually2.querySelectorAll('.sp-ani')
    const observerAni = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            paragraph2.forEach((span, index) => {
              let span_color = span.querySelector('span')
              if (span_color && span_color.classList.contains('sp-color')) {
                setTimeout(() => {
                  span_color.classList.add('active');
                }, 700);
              }
              if (span.classList.contains('flipUp')) {
                span.style.animation = `flipUp 1.3s ease forwards`
              } else {
                span.style.animation = `sp-fade-in 1.3s ease forwards`
              }
              span.style.animationDelay = `${index * 0.5 + 0.5}s`
            })
            observerAni.unobserve(gradually2)
          }
        })
      },
      {
        threshold: 0.3,
      }
    )
    observerAni.observe(gradually2)
  }
  const graduallyList3 = document.getElementsByClassName('sp-fade-box2')
  for (let gradually3 of graduallyList3) {
    const paragraph3 = gradually3.querySelectorAll('.sp-ani2')
    const observerAni = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            paragraph3.forEach((span, index) => {
              span.style.animation = `sp-fade-left 1s ease forwards`
              span.style.animationDelay = `${index * 0.3 + 1}s`
            })

            observerAni.unobserve(gradually3)
          }
        })
      },
      {
        threshold: 0.3,
      }
    )
    observerAni.observe(gradually3)
  }
  // 鏂囨湰娓愬嚭鍔ㄧ敾
  const graduallyList4 = document.getElementsByClassName('sp-fade-box3')
  for (let gradually4 of graduallyList4) {
    const paragraph4 = gradually4.querySelectorAll('.sp-ani3')
    const observerAni = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            paragraph4.forEach((span, index) => {
              if (span.classList.contains('up')) {
                span.style.animation = `sp-fade-top 1s ease forwards`
              } else if (span.classList.contains('down')) {
                span.style.animation = `sp-fade-down 1s ease forwards`
              } else {
                span.style.animation = `sp-fade-in 1s ease forwards`
              }
              span.style.animationDelay = `${index * 0.3 + 1}s`
            })

            observerAni.unobserve(gradually4)
          }
        })
      },
      {
        threshold: 0.3,
      }
    )
    observerAni.observe(gradually4)
  }
  const videos = document.querySelectorAll('.sp-video')
  const videoObserver = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.play().catch((error) => {
            // 濡傛灉鑷姩鎾斁澶辫触锛堟瘮濡傜敤鎴疯缃簡闃绘鑷姩鎾斁锛夛紝闈欓粯澶勭悊
            console.log('瑙嗛鑷姩鎾斁澶辫触:', error)
          })
        } else {
          entry.target.pause()
        }
      })
    },
    {
      threshold: 0.3,
    }
  )

  videos.forEach((video) => {
    videoObserver.observe(video)
  })
})



